import StudentRenderer from "Components/ModelRenderers/StudentRenderer";
import IStyle from "Interfaces/IStyle";
import Student from "Models/Student";
import React from "react";
import { Col, Row } from "react-bootstrap";

const styles:IStyle = {
	student: {
		// padding: 2
		minWidth: "10rem",
		maxWidth: "14rem",
	}
}
interface IProps {
	team: Student[];
	compact?: boolean;
}
export default function TeamRenderer(props: IProps) {
	const {team, compact} = props;

	return (<Row className="team-render">
		{team.map(student => 
			<Col className="team student" xs={3} lg={2}>
				<StudentRenderer link="/StudentInsights/%id%" compact={compact} model={student} />
			</Col>
		)}
	</Row>);

}